import React, { useCallback, useMemo } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { Box, Button, Stack } from '@mui/material';
import {
  HSpinner,
} from 'BaseComponents';
import { cleanRoom } from 'utils/spaUrls';
import { habuColors } from 'Theme';
import { useFetchCleanRoomQuestion, useFetchQuestionVersions, useUpdateCleanRoomQuestionVersion } from 'hooks/questionAPIs';
import { useHistory, useParams } from 'react-router-dom';


export const QuestionSwitchVersion = ({ question, onClose }) => {
  const history = useHistory();
  const { crId } = useParams();

  const {
    isLoading: isLoadingCRQuestion,
    isSuccess: isSuccessCRQuestion,
    data: cleanRoomQuestion,
  } = useFetchCleanRoomQuestion(
    '', question?.crqID, crId);

  const {
    isLoading: isLoadingVersions,
    isSuccess: isSuccessVersions,
    data: versions,
  } = useFetchQuestionVersions({ questionId: question?.ID });

  const {
    mutateAsync: updateVersion,
    isLoading: isUpdatingVersion,
  } = useUpdateCleanRoomQuestionVersion(crId, question?.crqID);

  const currentVersion = useMemo(() => (
    cleanRoomQuestion?.cleanRoomQuestion?.questionVersion ?? null),
  [cleanRoomQuestion?.cleanRoomQuestion?.questionVersion]);
  const isCurrentVersion = useCallback((version) => (version === currentVersion), [currentVersion]);

  const onVersionPreview = (version) => {
    history.push(
      cleanRoom.builderView(crId, question?.ID, version),
    );
  };

  const onVersionSelect = async (version) => {
    await updateVersion({ version });
    onClose();
  };

  return (
    <Stack spacing={2}>
      {isLoadingVersions && isLoadingCRQuestion && <HSpinner />}
      {isSuccessVersions && isSuccessCRQuestion && (
        <>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Flow Version</TableCell>
                  <TableCell>
                    <Typography variant='subtitle2' sx={{ color: habuColors.neutral['60'] }}>
                      Actions
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {versions.map((version) => (
                  <TableRow key={version}>
                    <TableCell>
                      {`v${version}${isCurrentVersion(version) ? ' (Current version)' : ''}`}
                    </TableCell>
                    <TableCell>
                      <Box display='flex' columnGap={1}>
                        <Button
                          variant='contained'
                          data-testid='preview-version-button'
                          {...(isCurrentVersion(version) ? {
                            disabled: true,
                          } : {
                            onClick: () => onVersionPreview(version),
                          })}
                        >
                          Preview this version
                        </Button>
                        <Button
                          variant='outlined'
                          data-testid='select-version-button'
                          endIcon={(
                            isUpdatingVersion
                          ) ? <HSpinner isButton />
                            : null}
                          {...(isCurrentVersion(version) ? {
                            disabled: true,
                          } : {
                            disabled: isUpdatingVersion,
                            onClick: () => onVersionSelect(version),
                          })}
                        >
                          Use this version
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </Stack>
  );
};
